import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { 
  Box, 
  Button, 
  Card, 
  CardContent, 
  Container, 
  Grid, 
  Typography,
  TextField,
  Divider
} from '@mui/material';
import { fetchProgramId, updateProgramById, updateProgramImage, fetchProgramImageById } from '../../../redux/actions/Actions';

const UpdateProgram = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const fetchProgramsById = useSelector((state) => state.getProgramsId.programsId);
  const selectedProgram = fetchProgramsById[0];
  const currentProgramImage = useSelector((state) => state.fetchProgramImageById.programImageById);
  const [errors, setErrors] = useState({});
  const [Tileimage, setTileimage] = useState(null);
  const [Bannerimage, setBannerimage] = useState(null);
  const [Brochure, setBrochure] = useState(null);

  const [formData, setFormData] = useState({
    program_name: '',
    duration: '',
    cost: '',
    target_audience: '',
    program_details: '',
    program_coverage: '',
    outcome: '',
    career_opportunities: '',
    registration_charge: '',
    gst: ''
  });

  useEffect(() => {
    dispatch(fetchProgramId(id));
    dispatch(fetchProgramImageById(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (selectedProgram) {
      setFormData({
        program_name: selectedProgram.program_name || '',
        duration: selectedProgram.duration || '',
        cost: selectedProgram.cost || '',
        target_audience: selectedProgram.target_audience || '',
        program_details: selectedProgram.program_details || '',
        program_coverage: selectedProgram.program_coverage || '',
        outcome: selectedProgram.outcome || '',
        career_opportunities: selectedProgram.career_opportunities || '',
        registration_charge: selectedProgram.registration_charge || '',
        gst: selectedProgram.gst || ''
      });
    }
  }, [selectedProgram]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handletileChange = (e) => {
    setTileimage(e.target.files[0]);
  };

  const handleBannerChange = (e) => {
    setBannerimage(e.target.files[0]);
  };

  const handleBrochureChange = (e) => {
    setBrochure(e.target.files[0]);
  };

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ['program_name', 'duration', 'cost', 'target_audience'];
    
    requiredFields.forEach(field => {
      if (!formData[field]?.trim()) {
        newErrors[field] = 'This field is required';
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    const programData = {
      program_name: formData.program_name,
      duration: formData.duration,
      cost: formData.cost,
      target_audience: formData.target_audience,
      program_details: formData.program_details,
      program_coverage: formData.program_coverage,
      outcome: formData.outcome,
      career_opportunities: formData.career_opportunities,
      registration_charge: formData.registration_charge,
      gst: formData.gst
    };

    dispatch(updateProgramById(programData, id));

    if (Tileimage || Bannerimage || Brochure) {
      const formDataWithImage = new FormData();
      if (Tileimage) formDataWithImage.append("tile_image", Tileimage);
      if (Bannerimage) formDataWithImage.append("banner_image", Bannerimage);
      if (Brochure) formDataWithImage.append("program_brochure", Brochure);
      dispatch(updateProgramImage(formDataWithImage, id));
    }

    navigate("/auth/allPrograms");
  };

  return (
    <Box sx={{ backgroundColor: "#000080", color: "#fff", minHeight: "100vh", py: 4 }}>
      <Container maxWidth="md">
        <Card sx={{ borderRadius: 2, overflow: "hidden" }}>
          <Box sx={{ backgroundColor: "#f8f9fa", p: 3, borderBottom: "1px solid #e0e0e0" }}>
            <Typography variant="h5" sx={{ fontWeight: 700, color: "#000" }}>
              Update Program: {selectedProgram?.program_name}
            </Typography>
          </Box>
          
          <CardContent>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                {/* Required Fields */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Program Name *"
                    name="program_name"
                    value={formData.program_name}
                    onChange={handleChange}
                    error={!!errors.program_name}
                    helperText={errors.program_name}
                  />
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Duration *"
                    name="duration"
                    value={formData.duration}
                    onChange={handleChange}
                    error={!!errors.duration}
                    helperText={errors.duration}
                  />
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Cost *"
                    name="cost"
                    value={formData.cost}
                    onChange={handleChange}
                    error={!!errors.cost}
                    helperText={errors.cost}
                  />
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Target Audience *"
                    name="target_audience"
                    value={formData.target_audience}
                    onChange={handleChange}
                    error={!!errors.target_audience}
                    helperText={errors.target_audience}
                  />
                </Grid>
                
                {/* Optional Fields */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="Program Details"
                    name="program_details"
                    value={formData.program_details}
                    onChange={handleChange}
                  />
                </Grid>
                
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="Program Coverage"
                    name="program_coverage"
                    value={formData.program_coverage}
                    onChange={handleChange}
                  />
                </Grid>
                
                {/* Image Uploads */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography variant="subtitle1" gutterBottom>
                      Tile Image
                    </Typography>
                    <input
                      type="file"
                      name="tile_image"
                      accept=".png, .jpg, .jpeg"
                      onChange={handletileChange}
                    />
                    {currentProgramImage?.tile_image_url && (
                      <Box sx={{ mt: 1 }}>
                        <a href={currentProgramImage.tile_image_url} target="_blank" rel="noreferrer">
                          View current tile image
                        </a>
                      </Box>
                    )}
                  </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography variant="subtitle1" gutterBottom>
                      Banner Image
                    </Typography>
                    <input
                      type="file"
                      name="banner_image"
                      accept=".png, .jpg, .jpeg"
                      onChange={handleBannerChange}
                    />
                    {currentProgramImage?.banner_image_url && (
                      <Box sx={{ mt: 1 }}>
                        <a href={currentProgramImage.banner_image_url} target="_blank" rel="noreferrer">
                          View current banner image
                        </a>
                      </Box>
                    )}
                  </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography variant="subtitle1" gutterBottom>
                      Program Brochure
                    </Typography>
                    <input
                      type="file"
                      name="program_brochure"
                      accept=".pdf"
                      onChange={handleBrochureChange}
                    />
                    {currentProgramImage?.brochure_url && (
                      <Box sx={{ mt: 1 }}>
                        <a href={currentProgramImage.brochure_url} target="_blank" rel="noreferrer">
                          View current brochure
                        </a>
                      </Box>
                    )}
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Divider sx={{ my: 2 }} />
                </Grid>
                
                {/* Action Buttons */}
                <Grid item xs={6}>
                  <Button
                    fullWidth
                    variant="outlined"
                    color="primary"
                    onClick={() => navigate(-1)}
                    sx={{ py: 1.5 }}
                  >
                    Cancel
                  </Button>
                </Grid>
                
                <Grid item xs={6}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    type="submit"
                    sx={{ py: 1.5 }}
                  >
                    Update Program
                  </Button>
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default UpdateProgram;